import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import { S1, S2, S3 } from '../../assests/ExportImageIcon'

const offers = [
    { img: S1, title: 'Flat 10% Off', subtitle: 'for student', ctaLabel: 'Book Now' },
    { img: S2, title: 'Flat 15% Off', subtitle: 'on Manali packages', ctaLabel: 'Book Now' },
    { img: S3, title: 'Flat 20% Off', subtitle: 'on Goa getaways', ctaLabel: 'Book Now' },
    { img: S1, title: 'Extra ₹500 Off', subtitle: 'for armed forces', ctaLabel: 'Book Now' },
    { img: S2, title: 'Flat 10% Off', subtitle: 'for senior citizens', ctaLabel: 'Book Now' },
    { img: S3, title: 'Flat 12% Off', subtitle: 'on early bookings', ctaLabel: 'Book Now' },
]

const SpecialOffer = () => {
    const prevRef = useRef(null)
    const nextRef = useRef(null)
    const swiperRef = useRef(null)

    useEffect(() => {
        const swiper = swiperRef.current
        if (!swiper) return
        swiper.params.navigation = {
            ...swiper.params.navigation,
            prevEl: prevRef.current,
            nextEl: nextRef.current,
        }
        swiper.navigation.init()
        swiper.navigation.update()
    }, [])

    return (
        <>
            <section className='specialOffer popularDestination paddingCmn'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='secHeadArea'>
                                <div className='mainHead'>Special Offer</div>
                                <Link to="/">View All</Link>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="carousel">
                                <Swiper
                                    modules={[Navigation, Autoplay]}
                                    spaceBetween={20}
                                    slidesPerView={1.2}
                                    loop
                                    autoplay={{ delay: 2000, disableOnInteraction: false, pauseOnMouseEnter: true }}
                                    onSwiper={(swiper) => { swiperRef.current = swiper }}
                                    breakpoints={{
                                        576: { slidesPerView: 2 },
                                        768: { slidesPerView: 3 },
                                        992: { slidesPerView: 3 },
                                        1200: { slidesPerView: 4 },
                                    }}
                                >
                                    {offers.map((offer, index) => (
                                        <SwiperSlide key={index} className="item">
                                            <div className='slidePart'>
                                                <img src={offer.img} alt={offer.title} />
                                                <div className='specialOfferContent'>
                                                    <div className='s1'>{offer.title}</div>
                                                    <div className='s2'>{offer.subtitle}</div>
                                                    <button className='commonBtn'>{offer.ctaLabel}</button>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                                {/* <button type="button" className="carouselNav carouselNav-prev" ref={prevRef} aria-label="Previous">&#8249;</button>
                                <button type="button" className="carouselNav carouselNav-next" ref={nextRef} aria-label="Next">&#8250;</button> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default SpecialOffer
